var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    { ref: "form" },
    [
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("v-text-field", {
                attrs: { label: "Driver Id", disabled: true },
                model: {
                  value: _vm.editableDriver.id,
                  callback: function($$v) {
                    _vm.$set(_vm.editableDriver, "id", $$v)
                  },
                  expression: "editableDriver.id"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("v-select", {
                attrs: {
                  items: _vm.driverStatuses,
                  label: "Status",
                  disabled: true
                },
                scopedSlots: _vm._u([
                  {
                    key: "selection",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.driverStatusToString(item)) + " "
                        )
                      ]
                    }
                  },
                  {
                    key: "item",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.driverStatusToString(item)) + " "
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.editableDriver.status,
                  callback: function($$v) {
                    _vm.$set(_vm.editableDriver, "status", $$v)
                  },
                  expression: "editableDriver.status"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("v-text-field", {
                attrs: { label: "First Name" },
                model: {
                  value: _vm.editableDriver.firstName,
                  callback: function($$v) {
                    _vm.$set(_vm.editableDriver, "firstName", $$v)
                  },
                  expression: "editableDriver.firstName"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("v-text-field", {
                attrs: { label: "Last Name" },
                model: {
                  value: _vm.editableDriver.lastName,
                  callback: function($$v) {
                    _vm.$set(_vm.editableDriver, "lastName", $$v)
                  },
                  expression: "editableDriver.lastName"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.editable
        ? _c(
            "v-row",
            { staticClass: "mt-3" },
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-4",
                      attrs: { disabled: !_vm.dirty },
                      on: { click: _vm.save }
                    },
                    [_vm._v(" Save ")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }